let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eiq0I")).then(() => parcelRequire('guBtq'));